import React from 'react'

const Settings = () => {
  return (
    <div className='p-5'>
      <h1>Settings Page Features</h1>
  
  <ul>
    <li><strong>Account Settings</strong>
      <ul>
        <li> • Change Username/Email</li>
        <li> • Change Password</li>
        <li> • Update Profile Picture</li>
      </ul>
    </li>
    <li><strong>Notification Preferences</strong>
      <ul>
        <li> • Email Notifications</li>
        <li> • Push Notifications</li>
        <li> • SMS Alerts</li>
        <li> • Set Notification Frequency (e.g., Daily, Weekly)</li>
      </ul>
    </li>
    <li><strong>Theme and Appearance</strong>
      <ul>
        <li> • Dark/Light Mode Toggle</li>
        <li> • Choose Color Themes</li>
        <li> • Adjust Font Size</li>
      </ul>
    </li>
    <li><strong>Privacy Settings</strong>
      <ul>
        <li> • Set Profile Visibility (Public/Private)</li>
        <li> • Block or Restrict Users</li>
        <li> • Manage Shared Data Permissions</li>
      </ul>
    </li>
    <li><strong>Language and Regional Settings</strong>
      <ul>
        <li> • Language Selection</li>
        <li> • Timezone Selection</li>
        <li> • Date and Number Formatting</li>
      </ul>
    </li>
    {/* <li><strong>Security Options</strong>
      <ul>
        <li>Two-Factor Authentication (2FA)</li>
        <li>View Login History</li>
        <li>Manage Sessions (Log Out from All Devices)</li>
      </ul>
    </li>
    <li><strong>Subscription and Billing</strong>
      <ul>
        <li>Manage Subscriptions</li>
        <li>Update Payment Methods</li>
        <li>View Billing History</li>
      </ul>
    </li>
    <li><strong>Advanced Features</strong>
      <ul>
        <li>Integrations with Third-Party Services</li>
        <li>Accessibility Settings (e.g., High Contrast Mode)</li>
        <li>Customizable Dashboard Layout</li>
        <li>Data and Storage Management</li>
      </ul>
    </li>
    <li><strong>Application Preferences</strong>
      <ul>
        <li>Set Default View on Login</li>
        <li>Auto-Save Options</li>
        <li>Enable/Disable Beta Features</li>
      </ul>
    </li>*/}
  </ul> 
    </div>
  )
}

export default Settings;